import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleTintoreria: IAbstractModule = {
  type: IModuleType.tintoreria,
  name: 'Tintoreria 6',
  hasScreen: false,
  columns: [
    [
      {
        name: "T5",
        connector: "5",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "T6",
        connector: "6",
        cell_size_id: 1,
        accessible: true,
      },
    ],
    [
      {
        name: "T7",
        connector: "7",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "T8",
        connector: "8",
        cell_size_id: 1,
        accessible: true,
      },
    ],
    [
      {
        name: "T13",
        connector: "13",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "T14",
        connector: "14",
        cell_size_id: 1,
        accessible: true,
      },
    ],
  ]
};
